// Pauses d'un relevé ou d'une soirée : [{ start, end, paid }]. Aucune n'est facturée ; paid dit si le chauffeur est payé,
// null tant que le répartiteur n'a pas choisi. Un ancien relevé à pause unique la garde, non payée.
export function sheetBreaks(row) {
  if (Array.isArray(row?.breaks)) return row.breaks;
  return row?.break_start || row?.break_end ? [{ start: row.break_start || null, end: row.break_end || null, paid: false }] : [];
}

export const EMPTY_BREAK = { start: null, end: null, paid: null };
export const breakComplete = pause => Boolean(pause?.start && pause?.end);
const span = pause => breakComplete(pause) ? Math.max(0, (Date.parse(pause.end) - Date.parse(pause.start)) / 1000) || 0 : 0;

// Pause payée au chauffeur : dans ses heures, facturée à personne.
export const paidBreakSeconds = row => sheetBreaks(row).filter(pause => pause.paid === true).reduce((sum, pause) => sum + span(pause), 0);
export const allBreakSeconds = row => sheetBreaks(row).reduce((sum, pause) => sum + span(pause), 0);

// Ce qui bloque la validation : une heure manquante, ou le choix payée / non payée.
export function breakReasons(row) {
  const pauses = sheetBreaks(row).filter(pause => pause.start || pause.end);
  return [...(pauses.some(pause => !breakComplete(pause)) ? ["Complétez les deux heures de la pause."] : []),
    ...(pauses.some(pause => breakComplete(pause) && pause.paid == null) ? ["Pause à classer : choisissez Payée ou Non payée."] : [])];
}

export const updateBreak = (row, index, changes) => sheetBreaks(row).map((pause, i) => i === index ? { ...pause, ...changes } : pause);
export const removeBreak = (row, index) => sheetBreaks(row).filter((_, i) => i !== index);
export const addBreak = row => [...sheetBreaks(row), { ...EMPTY_BREAK }];
